export const getSizeOfDevice = () => {
  return {
    clientHeight: window.innerHeight,
    clientWidth: window.innerWidth,
  };
};
